export default "__VITE_ASSET__BSeFA1bw__"